import { useTokenPrice } from "common";
import { StatCard } from "./StatCard";
import { formatAmount } from "./utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Stats = _ref => {
  var _round$roundMetadata$, _round$roundMetadata, _round$roundMetadata$2, _round$roundMetadata2;
  let {
    round,
    totalCrowdfunded,
    totalProjects,
    token,
    tokenSymbol,
    totalDonations,
    totalDonors,
    statsLoading
  } = _ref;
  const tokenAmount = (_round$roundMetadata$ = (_round$roundMetadata = round.roundMetadata) === null || _round$roundMetadata === void 0 || (_round$roundMetadata = _round$roundMetadata.quadraticFundingConfig) === null || _round$roundMetadata === void 0 ? void 0 : _round$roundMetadata.matchingFundsAvailable) !== null && _round$roundMetadata$ !== void 0 ? _round$roundMetadata$ : 0;
  const {
    data: poolTokenPrice
  } = useTokenPrice(token === null || token === void 0 ? void 0 : token.redstoneTokenId, token === null || token === void 0 ? void 0 : token.priceSource);
  const matchingPoolUSD = poolTokenPrice ? Number(poolTokenPrice) * tokenAmount : undefined;
  const matchingCapPercent = (_round$roundMetadata$2 = (_round$roundMetadata2 = round.roundMetadata) === null || _round$roundMetadata2 === void 0 || (_round$roundMetadata2 = _round$roundMetadata2.quadraticFundingConfig) === null || _round$roundMetadata2 === void 0 ? void 0 : _round$roundMetadata2.matchingCapAmount) !== null && _round$roundMetadata$2 !== void 0 ? _round$roundMetadata$2 : 0;
  const matchingCapTokenValue = tokenAmount * matchingCapPercent / 100;
  return /*#__PURE__*/_jsx("div", {
    className: "max-w-5xl m-auto w-full",
    children: /*#__PURE__*/_jsxs("div", {
      className: `xl:grid-cols-3 grid grid-cols-2 gap-2 sm:gap-4`,
      children: [/*#__PURE__*/_jsx(StatCard, {
        statValue: `${formatAmount(tokenAmount, true)} ${tokenSymbol}`,
        secondaryStatValue: `${matchingPoolUSD ? `($${formatAmount(matchingPoolUSD !== null && matchingPoolUSD !== void 0 ? matchingPoolUSD : 0)})` : ""}`,
        statName: "Matching Pool",
        isValueLoading: statsLoading
      }), /*#__PURE__*/_jsx(StatCard, {
        statValue: `$${formatAmount(totalCrowdfunded.toFixed(2))}`,
        statName: "Total USD Crowdfunded",
        isValueLoading: statsLoading
      }), !!matchingCapPercent && /*#__PURE__*/_jsx(StatCard, {
        statValue: `${matchingCapPercent.toFixed()}% `,
        secondaryStatValue: `(${formatAmount(matchingCapTokenValue, true)} ${tokenSymbol})`,
        statName: "Matching Cap",
        isValueLoading: statsLoading
      }), /*#__PURE__*/_jsx(StatCard, {
        statValue: formatAmount(totalProjects, true),
        statName: "Total Projects",
        isValueLoading: statsLoading
      }), /*#__PURE__*/_jsx(StatCard, {
        statValue: formatAmount(totalDonations, true),
        statName: "Total Donations",
        isValueLoading: statsLoading
      }), /*#__PURE__*/_jsx(StatCard, {
        statValue: formatAmount(totalDonors, true),
        statName: "Total Donors",
        isValueLoading: statsLoading
      })]
    })
  });
};